import {
  INVITE_ATTENDEES,
  INVITE_ATTENDEES_SUCCESS,
  INVITE_ATTENDEES_FAILED,
  SEARCH,
  SEARCH_SUCCESS,
  SEARCH_FAILED,
  CLEAR,
} from './constants';

export const inviteAttendeesAction = (deedId, users, emails) => ({
  type: INVITE_ATTENDEES,
  deedId,
  users,
  emails,
});
export const inviteAttendeesSuccessAction = () => ({
  type: INVITE_ATTENDEES_SUCCESS,
});
export const inviteAttendeesFailedAction = (error, errorCode) => ({
  type: INVITE_ATTENDEES_FAILED,
  error,
  errorCode,
});

export const searchAction = (term) => ({
  type: SEARCH,
  term,
});
export const searchSuccessAction = (results) => ({
  type: SEARCH_SUCCESS,
  results,
});
export const searchFailedAction = (error, errorCode) => ({
  type: SEARCH_FAILED,
  error,
  errorCode,
});

export const clearAction = () => ({
  type: CLEAR,
});
